import { onApiResponse } from "./api-responses";
import { maybeUpsellPlanLimit } from "./plan-limit-store";
import { announceWrite } from "./tab-sync";

/**
 * What the customer app does with every API response (see `api-responses.ts`):
 * any plan limit, from any endpoint, opens the upgrade dialog, and a write
 * tells other open tabs their data may have changed. Installed once by the
 * entry; returns a function that removes it.
 */
export function installResponseEffects(): () => void {
  return onApiResponse((res, init) => {
    // The body is read from a clone so the caller still gets it.
    if (res.status === 403) void upsellIfPlanLimit(res.clone());
    if (res.ok && isWrite(init?.method)) announceWrite();
  });
}

async function upsellIfPlanLimit(res: Response): Promise<void> {
  const data = await res.json().catch(() => null);
  maybeUpsellPlanLimit(res.status, data);
}

function isWrite(method: string | undefined): boolean {
  const m = method?.toUpperCase();
  return m === "POST" || m === "PUT" || m === "PATCH" || m === "DELETE";
}
